export function formatMatchingDesiresLabel(count: number): string {
  return `${count} shared ${count === 1 ? 'desire' : 'desires'}`;
}

export const COUNTERPART_SEPARATOR = '↔';

export function replacePartnerPlaceholder(text: string, replacementName: string) {
  return text.replace(/\[partner\]/gi, replacementName);
}

export function formatCounterpartPrompt(
  questionText: string,
  counterpartQuestionText: string,
  partnerAName: string,
  partnerBName: string,
) {
  return [
    replacePartnerPlaceholder(questionText, partnerBName),
    replacePartnerPlaceholder(counterpartQuestionText, partnerAName),
  ].join(` ${COUNTERPART_SEPARATOR} `);
}
